import { STEPS } from './constants';

// Three-step "how it works". Colors reference platform brand tokens (--brand-*).
export default function NrouteHowItWorks() {
  return (
    <section
      id="how-it-works"
      className="relative py-20 md:py-28"
      style={{ background: 'linear-gradient(180deg, var(--brand-primary) 0%, var(--brand-bg) 100%)' }}
    >
      <div className="mx-auto max-w-6xl px-4">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            From first question to clear route
          </h2>
          <p className="mt-4 text-lg text-slate-300">Three steps. No noise.</p>
        </div>

        <div className="relative mt-14 grid gap-8 md:grid-cols-3">
          {STEPS.map((step, i) => (
            <div key={step.number} className="relative">
              <div
                className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl text-xl font-bold"
                style={{ backgroundColor: 'var(--brand-secondary)', color: 'var(--brand-primary)' }}
              >
                {step.number}
              </div>
              <h3 className="mb-3 text-xl font-semibold text-white">{step.title}</h3>
              <p className="leading-relaxed text-slate-400">{step.body}</p>

              {i < STEPS.length - 1 && (
                <div
                  className="absolute top-7 -right-4 hidden h-px w-8 md:block"
                  style={{ background: 'linear-gradient(90deg, var(--brand-accent), transparent)' }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
